import * as React from 'react';
import { useSelector } from 'react-redux';
import * as Types from '../../types';

interface Props {
  requiredFeature: Types.FeatureFlag | Types.FeatureFlag[];
  children: React.ReactNode;
  notEnabledComponent?: React.ReactNode;
}

export const isRequiredFeatureEnabled = (
  features: Types.Feature[] = [],
  requiredFeature: Types.FeatureFlag | Types.FeatureFlag[],
): boolean => {
  if (Array.isArray(requiredFeature)) {
    for (const required of requiredFeature) {
      if (!features.some((f) => f.key === required && f.enabled)) {
        return false;
      }
    }

    return true;
  }

  return (
    features &&
    features.some(
      (feature) => feature.key === requiredFeature && feature.enabled,
    )
  );
};

export const RequiredFeatureEnabled: React.FC<Props> = (props) => {
  const features = useSelector((state: Types.State) => state.features);

  if (Array.isArray(props.requiredFeature)) {
    const hasEnabled = props.requiredFeature.some((feature) =>
      isRequiredFeatureEnabled(features, feature),
    );

    return <>{hasEnabled ? props.children : props.notEnabledComponent}</>;
  }

  if (isRequiredFeatureEnabled(features, props.requiredFeature)) {
    return <>{props.children}</>;
  }

  return <>{props.notEnabledComponent}</>;
};
